import { connect } from "react-redux";

// Constants
import { sections } from "src/constants";

// Component
import { CheckboxFilterComponent } from "src/components/filters";

// Selectors
import { acquiredFilterConfigSelector } from "src/selectors/ui_config_selectors/wounds";
import { createSectionSelectors } from "src/ui_processors/global/selector_creators";

// Actions
import { createSectionActions } from "src/ui_processors/global/action_creators";

// State
function mapStateToProps(state) {
  return {
    filterConfig: acquiredFilterConfigSelector(state),
    filterCheckedState: createSectionSelectors(
      sections.wounds
    ).createFilterCheckedStateSelector(acquiredFilterConfigSelector(state))(
      state
    )
  };
}

// Dispatch Actions
function mapDispatchToProps(dispatch) {
  return {
    selectCheckbox: filterObject => {
      dispatch(
        createSectionActions(sections.wounds).selectCheckbox(filterObject)
      );
    },
    deselectCheckbox: filterObject => {
      dispatch(
        createSectionActions(sections.wounds).deselectCheckbox(filterObject)
      );
    }
  };
}

export const SideBarAcquiredFilterContainerWounds = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckboxFilterComponent);
